module.exports = __webpack_public_path__ + "static/media/oberflex-makoremoire-1200x2490.eb3c5d3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-makoremoire-1200x2490.jpg
// module id = 1030
// module chunks = 37